"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var styled_components_1 = require("styled-components");
var libzl_1 = require("../libzl");
var RichDataIndicator = /** @class */ (function (_super) {
    __extends(RichDataIndicator, _super);
    function RichDataIndicator(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showMe: false,
            zlready: false,
            twoD: false,
            points: {},
            id: "",
            ignoreList: []
        };
        return _this;
    }
    RichDataIndicator.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.zlbolt === undefined && this.props.zlbolt) {
            libzl_1.initRichDataIndicator(this, this.props.zlbolt, 3); // DS_ZLPP
        }
    };
    RichDataIndicator.prototype.render = function () {
        return null;
        // let points = [];
        // for (let p in this.state.points){
        //     //let pos = this.state.points[p].viewport_pos;
        //     let min = this.state.points[p].bounds2DMin;
        //     let max = this.state.points[p].bounds2DMax;
        //     let h = (max.y-min.y)*100;
        //     let w = (max.x-min.x)*100;
        //     let x = (min.x*100)+(w/2);
        //     let y = (100-(max.y*100))+(h/2);
        //     points.push(<Marker key={p} left={x} top={y}></Marker>);
        //     points.push(<BoundingBox key={"b"+p} left={min.x*100} top={100-(max.y*100)} width={w} height={h}/>)
        // }
        // return (
        //     <RichInfo>
        //         {/* <BoundingBox left={25} top={25} width={50} height={50}/> */}
        //         {points}
        //     </RichInfo>);
    };
    return RichDataIndicator;
}(react_1.Component));
exports.default = styled_components_1.withTheme(RichDataIndicator);
//# sourceMappingURL=RichDataIndicator.js.map